<template>
  <img :src="convertSource(source, isDark)" width="25px" height="25px" alt />
</template>
<script>
import { mapGetters } from 'vuex'
import source from '@/mixins/source'

export default {
    name: 'orders-source',
    mixins: [source],
    props: {
        source: {
            required: true,
        },
    },
    computed: {
        ...mapGetters({
            isDark: 'isDark',
        }),
    },
}
</script>
